import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitStatus('loading');

    try {
      const formBody = new URLSearchParams({
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        service: formData.service,
        message: formData.message
      }).toString();

      const response = await fetch('https://readdy.ai/api/form/d5jm8imihetfqh7m5qag', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', phone: '', service: '', message: '' });
        setTimeout(() => setSubmitStatus('idle'), 5000);
      } else {
        setSubmitStatus('error');
        setTimeout(() => setSubmitStatus('idle'), 5000);
      }
    } catch (error) {
      setSubmitStatus('error');
      setTimeout(() => setSubmitStatus('idle'), 5000);
    }
  };

  const contactInfo = [
    {
      icon: 'ri-phone-fill',
      title: 'Teléfono',
      value: '640 920 362',
      link: 'tel:+34640920362',
      color: 'from-[#FFD700] to-[#FFA500]'
    },
    {
      icon: 'ri-mail-fill',
      title: 'Email',
      value: 'fontaneriaelrapido@gmail.com',
      link: 'mailto:fontaneriaelrapido@gmail.com',
      color: 'from-[#FFA500] to-[#FF8C00]'
    },
    {
      icon: 'ri-time-fill',
      title: 'Horario',
      value: 'Disponibles 24/7',
      link: null,
      color: 'from-[#FF8C00] to-[#FFD700]'
    }
  ];

  return (
    <section id="contacto" className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-block px-4 sm:px-6 py-2 border-2 border-[#3B82F6] rounded-full mb-4 sm:mb-6">
            <span className="text-[#3B82F6] text-xs sm:text-sm font-semibold">Contáctanos</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-[#1e3a8a] mb-4 sm:mb-6 px-4">
            Estamos Aquí Para
            <span className="block text-[#3B82F6] mt-2">Ayudarte</span>
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            Disponibles 24 horas para atender tus emergencias y consultas. Contáctanos por el medio que prefieras.
          </p>
        </div>

        {/* Contact Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 mb-12 sm:mb-16">
          {/* Phone Card */}
          <div className="bg-gradient-to-br from-[#EFF6FF] to-white rounded-2xl p-6 sm:p-8 border border-[#3B82F6]/20 hover:shadow-xl transition-all">
            <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-xl bg-gradient-to-br from-[#3B82F6] to-[#2563EB] flex items-center justify-center mb-4 sm:mb-6">
              <div className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center">
                <i className="ri-phone-line text-white text-xl sm:text-2xl"></i>
              </div>
            </div>
            <h3 className="text-xs sm:text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">TELÉFONO</h3>
            <p className="text-xl sm:text-2xl font-bold text-[#1e3a8a] mb-2">640 920 362</p>
            <p className="text-xs sm:text-sm text-gray-600">Disponible 24/7</p>
          </div>

          {/* Email Card */}
          <div className="bg-gradient-to-br from-[#EFF6FF] to-white rounded-2xl p-6 sm:p-8 border border-[#3B82F6]/20 hover:shadow-xl transition-all">
            <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-xl bg-gradient-to-br from-[#3B82F6] to-[#2563EB] flex items-center justify-center mb-4 sm:mb-6">
              <div className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center">
                <i className="ri-mail-line text-white text-xl sm:text-2xl"></i>
              </div>
            </div>
            <h3 className="text-xs sm:text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">EMAIL</h3>
            <p className="text-sm sm:text-base lg:text-lg font-bold text-[#1e3a8a] mb-2 break-all">fontaneriaelrapido@gmail.com</p>
            <p className="text-xs sm:text-sm text-gray-600">Respuesta en 24h</p>
          </div>

          {/* Location Card */}
          <div className="bg-gradient-to-br from-[#EFF6FF] to-white rounded-2xl p-6 sm:p-8 border border-[#3B82F6]/20 hover:shadow-xl transition-all">
            <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-xl bg-gradient-to-br from-[#3B82F6] to-[#2563EB] flex items-center justify-center mb-4 sm:mb-6">
              <div className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center">
                <i className="ri-map-pin-line text-white text-xl sm:text-2xl"></i>
              </div>
            </div>
            <h3 className="text-xs sm:text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">UBICACIÓN</h3>
            <p className="text-base sm:text-lg font-bold text-[#1e3a8a] mb-2">Valladolid, España</p>
            <p className="text-xs sm:text-sm text-gray-600">Servicio en toda la ciudad</p>
          </div>
        </div>

        {/* Form Section */}
        <div className="bg-gradient-to-br from-[#EFF6FF] to-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-12 border border-[#3B82F6]/20 shadow-xl">
          <div className="max-w-3xl mx-auto">
            <h3 className="text-2xl sm:text-3xl font-bold text-[#1e3a8a] mb-2 sm:mb-3 text-center">Solicita un Presupuesto Gratuito</h3>
            <p className="text-sm sm:text-base text-gray-600 mb-8 sm:mb-10 text-center">Completa el formulario y nos pondremos en contacto contigo lo antes posible</p>

            <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-6 sm:space-y-8">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 mb-4 sm:mb-6">
                <div>
                  <label htmlFor="name" className="block text-xs sm:text-sm font-bold text-gray-900 mb-2 sm:mb-3 uppercase tracking-wide">
                    Nombre Completo *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    className="w-full px-4 sm:px-6 py-3 sm:py-4 rounded-xl border-2 border-gray-200 focus:border-[#FFD700] focus:ring-4 focus:ring-[#FFD700]/20 outline-none transition-all text-sm sm:text-base"
                    placeholder="Tu nombre"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-xs sm:text-sm font-bold text-gray-900 mb-2 sm:mb-3 uppercase tracking-wide">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    className="w-full px-4 sm:px-6 py-3 sm:py-4 rounded-xl border-2 border-gray-200 focus:border-[#FFD700] focus:ring-4 focus:ring-[#FFD700]/20 outline-none transition-all text-sm sm:text-base"
                    placeholder="tu@email.com"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 mb-4 sm:mb-6">
                <div>
                  <label htmlFor="phone" className="block text-xs sm:text-sm font-bold text-gray-900 mb-2 sm:mb-3 uppercase tracking-wide">
                    Teléfono *
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    required
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    className="w-full px-4 sm:px-6 py-3 sm:py-4 rounded-xl border-2 border-gray-200 focus:border-[#FFD700] focus:ring-4 focus:ring-[#FFD700]/20 outline-none transition-all text-sm sm:text-base"
                    placeholder="+34 600 000 000"
                  />
                </div>
                <div>
                  <label htmlFor="service" className="block text-xs sm:text-sm font-bold text-gray-900 mb-2 sm:mb-3 uppercase tracking-wide">
                    Servicio Requerido *
                  </label>
                  <select
                    id="service"
                    name="service"
                    required
                    value={formData.service}
                    onChange={(e) => setFormData({ ...formData, service: e.target.value })}
                    className="w-full px-4 sm:px-6 py-3 sm:py-4 rounded-xl border-2 border-gray-200 focus:border-[#FFD700] focus:ring-4 focus:ring-[#FFD700]/20 outline-none transition-all text-sm sm:text-base cursor-pointer"
                  >
                    <option value="">Selecciona un servicio</option>
                    <option value="emergencia">Emergencia 24/7</option>
                    <option value="instalacion">Instalación</option>
                    <option value="mantenimiento">Mantenimiento</option>
                    <option value="drenaje">Sistemas de Drenaje</option>
                    <option value="calentadores">Calentadores</option>
                    <option value="remodelacion">Remodelación</option>
                  </select>
                </div>
              </div>

              <div className="mb-4 sm:mb-6">
                <label htmlFor="message" className="block text-xs sm:text-sm font-bold text-gray-900 mb-2 sm:mb-3 uppercase tracking-wide">
                  Mensaje *
                </label>
                <textarea
                  id="message"
                  name="message"
                  required
                  rows={6}
                  maxLength={500}
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  className="w-full px-4 sm:px-6 py-3 sm:py-4 rounded-xl border-2 border-gray-200 focus:border-[#FFD700] focus:ring-4 focus:ring-[#FFD700]/20 outline-none transition-all resize-none text-sm sm:text-base"
                  placeholder="Describe tu necesidad o proyecto..."
                ></textarea>
                <p className="text-xs sm:text-sm text-gray-500 mt-2">Máximo 500 caracteres</p>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                disabled={submitStatus === 'loading'}
                className="w-full bg-gradient-to-r from-[#3B82F6] to-[#2563EB] text-white py-4 sm:py-5 rounded-full text-sm sm:text-base font-bold hover:shadow-2xl hover:shadow-[#3B82F6]/30 transition-all flex items-center justify-center gap-3 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {submitStatus === 'loading' ? (
                  <>
                    <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                    <span>Enviando...</span>
                  </>
                ) : (
                  <>
                    <span>Enviar Solicitud</span>
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-send-plane-fill"></i>
                    </div>
                  </>
                )}
              </button>

              {submitStatus === 'success' && (
                <div className="bg-green-50 border-2 border-green-200 text-green-800 px-4 sm:px-6 py-3 sm:py-4 rounded-xl flex items-center gap-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i className="ri-checkbox-circle-fill text-xl sm:text-2xl"></i>
                  </div>
                  <span className="font-semibold text-sm sm:text-base">¡Mensaje enviado! Te contactaremos pronto.</span>
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-50 border-2 border-red-200 text-red-800 px-4 sm:px-6 py-3 sm:py-4 rounded-xl flex items-center gap-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i className="ri-error-warning-fill text-xl sm:text-2xl"></i>
                  </div>
                  <span className="font-semibold text-sm sm:text-base">Error al enviar. Por favor, intenta de nuevo.</span>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
